<template>
  <div>
    <small style="height: 55px;" 
      class="w-100 border-bottom py-1 px-2 bg-light d-flex justify-content-between align-items-center">
      <div style="width: 100px;">TOTAL: {{ filteredOrders.length }}</div>
      <input type="search" class="form-control search m-4 p-2"
        v-model="filter" placeholder="Type here to search..." />
    </small>
    <div class="text-muted text-center p-4" v-if="orders.length == 0">
      No <strong>{{ selectedStatus.name }}</strong> orders
    </div>    
    <div class="list-group list-group-flush border-bottom" id="list">
      <router-link
        :to="'/outbound/' + o.status.slug + '/' + o.id"
        class="list-group-item list-group-item-action flex-row border-bottom"
        :class="{ active: order.id == o.id }"
        v-for="o in filteredOrders"
        :key="o.id" style="cursor: pointer"
      >
        <div class="d-flex w-100 justify-content-between">
          <div class="mr-3">
            <img :src="o.client.logo_url" />
          </div>
          <div class="d-flex w-100 justify-content-between">
            <strong>
              {{ o.client.nickname }}<br />
              <small style="font-weight: 400">PO: {{ o.po_number }}</small>
            </strong>
            <small class="text-right">
              {{ calendar(o.created_at) }}<br />
            </small>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
  import store from '@/stores/inbound.js'
  import moment from 'moment'

  export default {
    name: 'orders-list',

    props: ['orders', 'selectedStatus'],

    data() {
      return {
        filter: ''
      }
    },

    methods: {
      calendar(date) {
        return moment(date).format('l')
      }
    },

    computed: {
      filteredOrders() {
        if (this.filter == '') {
          return this.orders
        }

        return this.orders.filter(order => {
          if (order.po_number.toLowerCase().includes(this.filter) 
            || order.client.nickname.toLowerCase().includes(this.filter)
          ) {
            return true
          }
        })
      },

      order() {
        return store.state.order
      }
    }
  }
</script>

<style scoped>
.search {
  outline: none;
  background: none;
  border: 0;
}

  .list-group-item img {
    max-height: 50px;
    border-radius: 15px;
  }

  .list-group {
    height: calc(100vh - 82px);
    overflow-y: auto;
  }
</style>